/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const NAME = 'generalSettings/documentSeries';
